var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCbo = function SvgCbo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 27,
    x: 0.5,
    y: 4.5,
    fill: "url(#a)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7B8E",
    fillRule: "nonzero",
    d: "M10.872 29.096c-.379 0-.72-.06-1.024-.18a2.03 2.03 0 0 1-.776-.536 2.468 2.468 0 0 1-.496-.888 3.967 3.967 0 0 1-.176-1.244c0-.47.059-.887.176-1.252a2.62 2.62 0 0 1 .496-.92c.213-.248.472-.436.776-.564a2.615 2.615 0 0 1 1.024-.192c.517 0 .944.105 1.28.316.336.21.605.543.808.996l-1.048.544a1.247 1.247 0 0 0-.348-.564c-.157-.141-.388-.212-.692-.212-.357 0-.644.116-.86.348-.216.232-.324.57-.324 1.012v.896c0 .443.108.78.324 1.012.216.232.503.348.86.348.299 0 .537-.081.716-.244.179-.163.31-.359.396-.588l.992.576c-.208.427-.481.756-.82.988-.339.232-.767.348-1.284.348zm2.952-5.68h2.712c.464 0 .825.13 1.084.392.259.261.388.608.388 1.04 0 .213-.028.395-.084.544-.056.15-.13.272-.224.368a.86.86 0 0 1-.328.212c-.125.045-.26.07-.404.076v.048c.133 0 .273.024.42.072a1.196 1.196 0 0 1 .712.632c.083.165.124.368.124.608 0 .219-.036.425-.108.62a1.582 1.582 0 0 1-.3.508 1.4 1.4 0 0 1-.456.34 1.338 1.338 0 0 1-.576.124h-2.96v-5.584zm1.216 4.56h1.4c.16 0 .287-.044.38-.132a.487.487 0 0 0 .14-.372V27.2a.487.487 0 0 0-.14-.372.531.531 0 0 0-.38-.132h-1.4v1.28zm0-2.272h1.208c.16 0 .285-.045.376-.136a.508.508 0 0 0 .136-.376v-.24a.508.508 0 0 0-.136-.376.508.508 0 0 0-.376-.136H15.04v1.264zm6.36-2.384c.368 0 .704.061 1.008.184.304.123.563.305.776.548.213.243.379.544.496.904.117.36.176.777.176 1.252s-.059.892-.176 1.252c-.117.36-.283.661-.496.904a2.03 2.03 0 0 1-.776.548 2.67 2.67 0 0 1-1.008.184 2.67 2.67 0 0 1-1.008-.184 2.03 2.03 0 0 1-.776-.548 2.543 2.543 0 0 1-.496-.904 4.043 4.043 0 0 1-.176-1.252c0-.475.059-.892.176-1.252.117-.36.283-.661.496-.904a2.03 2.03 0 0 1 .776-.548 2.67 2.67 0 0 1 1.008-.184zm0 1.08c-.368 0-.655.12-.86.36-.205.24-.308.584-.308 1.032v.832c0 .448.103.792.308 1.032.205.24.492.36.86.36s.655-.12.86-.36c.205-.24.308-.584.308-1.032v-.832c0-.448-.103-.792-.308-1.032-.205-.24-.492-.36-.86-.36z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 6,
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M18 16a2 2 0 0 1 2 2c-.987 1.34-2.32 2.006-4 2-1.679-.006-3.012-.673-4-2l.005-.15A2 2 0 0 1 14 16zm-2-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A79",
    d: "M17.842 16c.31.254.405.475.405.764l.001.31c.526.103.652.605.652.935v.713a.282.282 0 0 1-.285.278.282.282 0 0 1-.285-.278c0-.125.085-.232.203-.266v-.447c0-.301-.218-.545-.489-.545-.27 0-.489.244-.489.545v.447c.118.034.204.14.204.266a.282.282 0 0 1-.285.278.284.284 0 0 1-.278-.214l-.007-.064v-.713c0-.33.125-.832.651-.935l.002-.31c0-.403-.199-.493-.56-.764h.56zm-3.148 0c-.244.557-.363.947-.358 1.17.008.29.076.665.4.754a.404.404 0 0 1 .288-.118c.222 0 .402.175.402.391 0 .217-.18.392-.402.392a.401.401 0 0 1-.386-.28c-.42-.103-.738-.473-.738-1.14 0-.53.12-.92.358-1.169h.436zm.213 0s2.233 0 2.233.01c-.094.521-.466 1.166-1.116 1.934-.654-.77-1.026-1.419-1.117-1.944z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    x: 13,
    fill: "#498FFF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5D4FF",
    d: "M16 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCbo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cbo.7f07da2e.svg";
export { ForwardRef as ReactComponent };